import { Checkbox, Collapse, Flex, Form } from 'antd'
import { FormInstance } from 'antd/lib'

import { GetPermissionsListResponseItem2 } from 'src/api/requests'
import { Text } from 'src/components'

import { useStyles } from '../styles'
import { groupByModuleAndDomain } from '../utils'

type Props = {
  form: FormInstance
  permissions?: GetPermissionsListResponseItem2[]
}

export const PermissionSelector = ({ permissions, form }: Props) => {
  const grouped = groupByModuleAndDomain(permissions)

  const { styles } = useStyles()

  const selectedPermissions = Form.useWatch('permissions', form) || []

  const onCheckboxChange = (id?: string) => {
    const current = form.getFieldValue('permissions') || []
    const isSelected = current.includes(id)
    const updated = isSelected
      ? current.filter((permId: string) => permId !== id)
      : [...current, id]

    form.setFieldsValue({ permissions: updated })
  }

  const moduleItems = Object?.entries(grouped)?.map(([module, domains]) => ({
    key: module,
    label: <Text strong>{module}</Text>,
    children: (
      <Collapse
        bordered={false}
        destroyInactivePanel={false}
        ghost
        size="small"
        items={Object?.entries(domains)?.map(([domain, perms]) => ({
          key: domain,
          label: (
            <Text strong className={styles.domainFontSize}>
              {domain}
            </Text>
          ),
          children: (
            <Flex vertical gap={6} className={styles.permissionList}>
              {perms?.map((perm) => (
                <Checkbox
                  key={perm?.id}
                  value={perm?.id}
                  checked={selectedPermissions?.includes(perm?.id)}
                  onChange={() => onCheckboxChange(perm?.id)}
                  className={styles.permissionCheckbox}
                >
                  <Text className={styles.domainFontSize}>{perm?.name}</Text>
                </Checkbox>
              ))}
            </Flex>
          ),
          className: styles.permissionsDomainCollapse
        }))}
        className={styles.permissionsModuleCollapse}
      />
    ),
    className: styles.moduleCollapseWrapper
  }))

  return (
    <Collapse
      items={moduleItems}
      className="full-width"
      size="small"
      bordered={false}
      accordion={false}
      destroyInactivePanel={false}
    />
  )
}
